import $ from "jquery";

export default () => {
    var addressId = null;
    $('#form-cart-collect').on('change', function() {
        addressId = $(this).find('[name="collect_address"]:checked').val();
        var $customer_address = $(this).attr('data-address');

        if(addressId) {
            var url = '/?view=includes/order_delivery_schedules&module=PickupDelivery&address='+addressId+'&customerAddress='+$customer_address;
            $.ajax({
                url : url,
                type: 'GET',
                beforeSend: function() {
                    $('#ScheldulesWrapper').html('<div class="OrderDelivery-intro__subtitle text-center">Chargement...</div>');
                },
                success: (data) => {
                    $('#ScheldulesWrapper').html(data);
                }
            })
        }
    });

    $(document).on('click', '#form-cart-delivery-pickup [type="submit"]', function(e) {
        e.preventDefault();

        var url = '/pickup-order-address?pickup_address_id='+addressId;
        $.ajax({
            url : url,
            type: 'GET',
            beforeSend: function() {
                $('#form-cart-delivery-pickup [type="submit"]').attr('disabled', true);
            },
            error: function() {
                $('#form-cart-delivery-pickup [type="submit"]').attr('disabled', false);
            },
            success: () => {
                $('#form-cart-delivery-pickup').submit();
            }
        })
        
    });
}


// WEBPACK FOOTER //
// ./assets/src/js/modules/SelectCollectPoint.js